import { FeiertagsDynamik } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/feiertagsausgleichRegelung';
import { Mitarbeiter_Feiertagsdynamik } from '@/gql/graphql';

export function mapFeiertagsdynamik(
  feiertagsdynamik: FeiertagsDynamik,
): Mitarbeiter_Feiertagsdynamik {
  switch (feiertagsdynamik) {
    case 'KEINE':
      return Mitarbeiter_Feiertagsdynamik.Keine;
    case 'AUF_SOLL_AUFFUELLEN':
      return Mitarbeiter_Feiertagsdynamik.AufSollAuffuellen;

    default:
      feiertagsdynamik satisfies never;
      throw new Error(
        `Unexpected feiertagsdynamik: ${String(feiertagsdynamik)}`,
      );
  }
}
